export const isDispatchHeaderActive = () => {
  return JSON.parse(localStorage.getItem('isDispatchHeaderActive'));
};
